<template>
  <div class="site-setup-social-media-content">
    <div class="social-networks">
      <div
        v-for="network in primaryNetworks"
        @click="activateNetwork(network)"
        :class="networkClasses(network)"
        :key="network"
      >
        <Sprite :name="network" />
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="networkInitiated">
        <AddSocialNetwork
          @currentPlatforms="currentPlatforms"
          :companyId="companyId"
          :siteId="siteId"
          :key="_uid"
          :platform="activeNetwork"
        />
      </div>

      <div class="init-message" v-else>
        <p>Click on an icon above to connect your social media account.<br>If you don't use social media, you can continue.</p>
      </div>
    </transition>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'
import AddSocialNetwork from '@/components/SiteSetup/AddSocialNetwork'

export default {
  name: 'socialMediaContent',

  data() {
    return {
      primaryNetworks: [
        'facebook',
        'twitter',
        'instagram',
        'youtube',
        'pinterest',
        'linkedin',
        'snapchat'
      ],
      platformsAdded: [],
      activeNetwork: '',
      networkInitiated: false
    }
  },

  props: {
    companyId: String,
    siteId: String
  },

  components: {
    Sprite,
    AddSocialNetwork
  },

  methods: {
    activateNetwork(network) {
      this.networkInitiated = true
      this.activeNetwork = network
    },

    currentPlatforms(platforms) {
      this.platformsAdded = platforms
    }
  },

  computed: {
    currentActiveNetwork() {
      return (network) => {
        return network === this.activeNetwork
      }
    },

    networkAdded() {
      return (network) => {
        return this.platformsAdded.find((account) => account.key === network)
      }
    },

    networkClasses() {
      return (network) => {
        return [
          'social-network',
          `network-${network}`,
          {'is-active': this.currentActiveNetwork(network)},
          {'is-added': this.networkAdded(network)}
        ]
      }
    }
  },

  mounted() {
    let text =
      'Do you use social media? If so, we can add links to your website to keep your customers updated.'

    this.$emit(
      'setContinue',
      {
        name: 'otherContentFinal'
      },
      text
    )
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/animations'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.social-networks
  display: flex
  align-items: center
  justify-content: center
  margin-top: $gap-x-large

.init-message
  text-align: center
  margin-top: $gap-large

.social-network, .social-toggle
  background: rgba(0, 0, 0, 0.1)
  width: 40px
  height: 40px
  border-radius: 5px
  margin: 0 $gap-small
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer
  transition: transform .2s ease-in-out, background .3s 3.75s ease-in-out

  &.is-active
    transform: scale(1.3)

  &.is-added
    &.network-facebook
      background: #3b5998

    &.network-twitter
      background: #00acee

    &.network-instagram
      background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)

    &.network-youtube
      background: #c4302b

    &.network-pinterest
      background: #c8232c

    &.network-linkedin
      background: #0e76a8

    &.network-snapchat
      background: #efdc00

.sprite
  fill: #fff
  width: 30px
  height: 30px
</style>
